import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import type { TRGBAColorWith1AtTheEnd } from 'settings/colors'
import { colors } from 'settings/colors'
import { PersistentStoreName } from 'stores/_utils/persistentStore/persistenceStoresCleanUpMap'
import { persistentInit } from 'stores/_utils/persistentStore/persistentStore'
import { selectedValueGroupsStore } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'
import type { TMapVisualValueGroup } from './mapVisualValueGroup'
import { defaultMapVisualValueGroup } from './mapVisualValueGroup'
import { MAP_VISUAL } from './types'

export const generateDefaultHeatmapHighLowColors = () => [
  colors.highLowHeatmapStrongBlue,
  colors.highLowHeatmapMediumBlue,
  colors.highLowHeatmapMediumYellow,
  colors.highLowHeatmapMediumOrange,
  colors.highLowHeatmapStrongRed,
]

export const generateDefaultHeatmapDangerColors = () => [
  colors.dangerHeatmapSoftYellow,
  colors.dangerHeatmapStrongYellow,
  colors.dangerHeatmapSoftOrange,
  colors.dangerHeatmapStrongOrange,
  colors.dangerHeatmapSoftRed,
  colors.dangerHeatmapStrongRed,
]

export const mapControlsStore = persistentInit<{
  manualExtremes: boolean
  heatmapColoring: TRGBAColorWith1AtTheEnd[]
  heatmapExtremes: {
    min: number
    max: number
  }
  loadingCurrentValues: boolean
  mapVisuals: Record<MAP_VISUAL, boolean>
  mapVisualValueGroup: TMapVisualValueGroup
  selectedEmitters: TEmitterType[]
  showCurrentValuesOnSwagworld: boolean
  showMapBadgeNames: boolean
  useAggregation: boolean
  keyForRefreshingMap: string | null
}>({
  initialState: {
    manualExtremes: false,
    heatmapColoring: generateDefaultHeatmapHighLowColors(),
    heatmapExtremes: { min: 5, max: 30 },
    loadingCurrentValues: false,
    mapVisuals: {
      [MAP_VISUAL.BLOCK]: true,
      [MAP_VISUAL.PROPERTY]: true,
      [MAP_VISUAL.POINT]: true,
      [MAP_VISUAL.SCD]: true,
      [MAP_VISUAL.IRRIGATION_ZONE]: true,
      [MAP_VISUAL.IMAGE_OVERLAY]: true,
      [MAP_VISUAL.TRAP]: true,
      [MAP_VISUAL.REGION]: true,
    },
    mapVisualValueGroup: defaultMapVisualValueGroup,
    selectedEmitters: [],
    showCurrentValuesOnSwagworld: true,
    showMapBadgeNames: false,
    useAggregation: true,
    keyForRefreshingMap: null,
  },
  keysToPutInPersistentStorage: {
    heatmapColoring: false,
    heatmapExtremes: true,
    loadingCurrentValues: false,
    manualExtremes: true,
    mapVisuals: false,
    mapVisualValueGroup: true,
    selectedEmitters: true,
    showCurrentValuesOnSwagworld: true,
    showMapBadgeNames: true,
    useAggregation: true,
    keyForRefreshingMap: false,
  },
  keysToPutInURL: {
    heatmapColoring: false,
    heatmapExtremes: true,
    loadingCurrentValues: false,
    manualExtremes: true,
    mapVisuals: false,
    mapVisualValueGroup: false,
    selectedEmitters: true,
    showCurrentValuesOnSwagworld: false,
    showMapBadgeNames: false,
    useAggregation: true,
    keyForRefreshingMap: false,
  },
  storeName: PersistentStoreName.MAP_CONTROLS_STORE,
})

// doing this will allow our heatmap to scale dynamically when a new valueType is on the map
selectedValueGroupsStore.subscribeToChanges(
  (s) => [s.primaryValueGroup],
  () => {
    mapControlsStore.setState((s) => ({ ...s, manualExtremes: false }))
  },
)
